export default Object.freeze({
	TOPIC_ID_SEARCH_PARAM: 'sznDiscussionTopicId',
	SHOW_COMMENT_ID_SEARCH_PARAM: 'sznDiscussionCommentId'
});
